export enum OrderTransactionTypeEnum {
  Mdo = 'Mdo',
  Pdo = 'Pdo',
  Ro = 'Ro',
  Wro = 'Wro',
  Pio = 'Pio'
}

export const getOrderTransactionType = (type: OrderTransactionTypeEnum) => type

export const getOrderTransactionTypeList = () => [
  { value: OrderTransactionTypeEnum.Mdo, text: getOrderTransactionType(OrderTransactionTypeEnum.Mdo) },
  { value: OrderTransactionTypeEnum.Pdo, text: getOrderTransactionType(OrderTransactionTypeEnum.Pdo) },
  { value: OrderTransactionTypeEnum.Ro, text: getOrderTransactionType(OrderTransactionTypeEnum.Ro) },
  { value: OrderTransactionTypeEnum.Wro, text: getOrderTransactionType(OrderTransactionTypeEnum.Wro) },
  { value: OrderTransactionTypeEnum.Pio, text: getOrderTransactionType(OrderTransactionTypeEnum.Pio) },
]
